// src/components/Navbar.tsx
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import MainNav from './MainNav';
import MobileMenu from './NavbarComponents/MobileMenu';
import DesktopCTAs from './NavbarComponents/DesktopCTAs';
import { navLinks } from './NavbarComponents/navData';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <motion.header 
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-stone-900 shadow-md' : 'bg-stone-900/95 backdrop-blur-md'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container-custom mx-auto">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center z-20"
            onClick={() => setMobileMenuOpen(false)}
          >
            <h1 className="text-2xl font-bold text-white">
              Kamen d.o.o.
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:block lg:flex-1 lg:ml-10">
            <MainNav />
          </div>

          {/* CTA Buttons */}
          <DesktopCTAs scrolled={scrolled} />

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden z-20 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? "Zapri meni" : "Odpri meni"}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <MobileMenu 
          isOpen={mobileMenuOpen} 
          navLinks={navLinks} 
          onLinkClick={closeMobileMenu}
        />
      </div>
    </motion.header>
  );
};

export default Navbar;